import { InputContainer } from "./style";

export function InputData({width, value, onClick, label, errorCpf}) {
  return (
    <InputContainer width={width} errorCpf={errorCpf}>
      <p>{label}</p>
      <input 
        type="text" 
        value={value} 
        onClick={onClick}
      />
      <span>
        {errorCpf}
      </span>
    </InputContainer>
  )
}